module.exports = __webpack_public_path__ + "static/media/page_20b.8bc3aaa2.jpg";